module.exports = __webpack_public_path__ + "img/CM-SL-CA-Honda-Modern.8159bebc.jpeg";